<form class="aw-dialog">
  <!-- Icon -->
  <object type="image/svg+xml" style="width: 166px; height: 131px;" 
    data="assets/images/org/ic_req_complete.svg">Your browser does not support SVGs</object>
  <!-- /.Icon -->

  <!-- Form Headers -->
  <div class="aw-dialog-header" style="margin-bottom: 16px;">Organization Request Complete!</div>

  <p style="margin-bottom: 32px;">
    Your organization is pending. <br/>
    We will email you when your organization request has been reviewed.
    The process typically takes one to two days.
  </p>
  <!-- Button -->
  <button class="aw-btn aw-btn-blue" routerLink="/org/list">Ok</button>
  <!-- /.Button -->
</form>
